import isEmpty from 'lodash-es/isEmpty';
import { SnackbarProvider } from 'notistack';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import CustomNotification from '../components/NotificationSSE/components/CustomNotification';
import {
  PermissionContextProvider,
  UserContextProvider,
  WorkspaceContextProvider,
  WorkspaceSKUContextProvider,
  BusinessUnitContextProvider,
  TokenContextProvider,
} from '../context';
import publicAllowedUrlPaths from '../utils/publicAllowedUrlPaths';
import { getAuthToken, logout, setNavURL } from '../utils/token';
import { useConversationWidgetStore } from '../utils/useConversationWidgetStore';

import Routes from './Routes';

export const AppRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const setSearchQuery = useConversationWidgetStore((state) => state.setSearchQuery);
  useEffect(() => {
    if (
      !publicAllowedUrlPaths.includes(location.pathname) &&
      !location.pathname.includes('/data-protection') &&
      isEmpty(getAuthToken())
    ) {
      setNavURL(location.pathname);
      logout();
    } else if (
      window.location.hostname === 'dataprivacy.wisestep.com' &&
      window.location.toString().includes('/#/')
    ) {
      const relativePath = window.location.toString().split('/#/');
      const companyDetails = relativePath[1].split('/');
      const details = companyDetails[2].split('?');
      if (details.length > 1)
        navigate(`/data-protection/${companyDetails[0]}/${details[0]}/view?${details[1]}`);
      else navigate(`/data-protection/email/${companyDetails[0]}/${details[0]}`);
    }
  }, [location, location.pathname, navigate]);
  useEffect(() => {
    setSearchQuery(null);
  }, [location.key, setSearchQuery]);
  return (
    <UserContextProvider>
      <WorkspaceContextProvider>
        <WorkspaceSKUContextProvider>
          <PermissionContextProvider>
            <BusinessUnitContextProvider>
              <TokenContextProvider>
                <SnackbarProvider
                  Components={{
                    customNotification: CustomNotification,
                  }}
                >
                  <Routes />
                </SnackbarProvider>
              </TokenContextProvider>
            </BusinessUnitContextProvider>
          </PermissionContextProvider>
        </WorkspaceSKUContextProvider>
      </WorkspaceContextProvider>
    </UserContextProvider>
  );
};
